import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const footerWrapper = css`
  background: var(--neutral-white-base);
  box-shadow: 0 ${pxToRem(-4)} ${pxToRem(8)} 0 rgba(0, 0, 0, 0.2);
  padding: ${spacing.md}px;
  width: 100%;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding: ${spacing.xl}px;
      text-align: right;
    `,
  )}
`;
